import { Form } from "@themesberg/react-bootstrap";
import React from "react";

export const SelectBox = ({ Label, name, register, errors, validationRules, watch, children, onChange, disabled = false, ...rest }) => {
    const value = watch(name); // Get the selected value
    const isRequired = validationRules?.required; 
      const {
                onChange: reactHookFormOnChange,
                ...restRegister
            } = register(name, validationRules);
    return (
        <>
            {Label && <Form.Label className="mb-0">{Label} {isRequired && <span style={{ color: "red" }}>*</span>}</Form.Label>}
            <Form.Select
                disabled={disabled}
                className="shadow-none"
                {...register(name, validationRules)}
                onChange={(e) => {
                    reactHookFormOnChange(e); // ✅ trigger RHF validation
                    if (onChange) onChange(e); // ✅ trigger your custom logic
                }}
                isInvalid={!!errors[name]}  // Show invalid if there's an error
                isValid={!errors[name] && value} // Show valid only if a value is selected
                {...rest}
            >
                {children} {/* Render options passed as children */}
            </Form.Select>
            {errors[name] && (
                <Form.Control.Feedback type="invalid">
                    {errors[name].message}
                </Form.Control.Feedback>
            )}
        </>
    );
};
